module.exports = __webpack_public_path__ + "img/u2465.2039719c.png";